<template>
  <v-card :loading="store.fetchingFlags.clientes" :disabled="store.fetchingFlags.clientes" flat>
    <v-container>
      <v-alert
        v-if="store.errorMessages.clientes"
        type="error"
        class="mb-4"
    >
      
      <template v-slot:text>
        {{ store.errorMessages.clientes }}
        <v-btn
          text="Reintentar"
          variant="outlined"
          @click="retryFetchData"
        >
        </v-btn>
      </template>
    </v-alert>

    <v-row class="pa-0">
      <v-col cols="12" md="6">
        <FormField
          v-model="store.formData.tipoDestinatario"
          field-type="v-select"
          label="Tipo de destinatario"
          :items="tiposDeDestinatarios"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="store.showClienteField">
        <FormField
          v-model="store.formData.clienteDestinatario"
          field-type="v-autocomplete"
          label="Cliente"
          :items="store.apiCache.clientes"
          :rules="[rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="store.showEmpresaField">
        <FormField
          v-model="store.formData.empresaDestinataria"
          field-type="v-autocomplete"
          label="Empresa"
          :items="store.apiCache.oficinas"
          :rules="[rules.required]"
        />
      </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import { onMounted } from 'vue'
import { useSolicitudMensajeriaStore } from '@/stores/solicitudMensajeria'
import FormField from './FormField.vue'

const store = useSolicitudMensajeriaStore()

const tiposDeDestinatarios = ["Mensajeria Interna", "Clientes"]

const rules = {
  required: (value) => !!value || "Campo requerido"
}


const retryFetchData = async () => {
  await store.fetchClientes()
}

onMounted( async () => {
  await store.fetchClientes()
})
</script> 